import { takeLatest, call, put } from 'redux-saga/effects';
import {
  GET_PORTOFOLIO_START,
  POST_PORTOFOLIO_ERROR,
  POST_PORTOFOLIO_START,
  POST_PORTOFOLIO_SUCCESS
} from '../../types';

import apiCall from '../../../api';

export function* create({ payload }) {
  try {
    const url = '/portofolio/create';
    const method = 'POST';
    const data = payload.data;
    const headers = { Authorization: `Bearer ${payload.token}` };

    const results = yield call(apiCall, url, method, data, headers);

    yield put({ type: POST_PORTOFOLIO_SUCCESS, results: results.data });
    yield put({
      type: GET_PORTOFOLIO_START,
      payload: { lang: null, token: payload.token }
    });

    if (payload.navigate) {
      payload.navigate('/app/content-management/manage-portofolio');
    }
  } catch (error) {
    console.error('[POST_PORTOFOLIO_ERROR]', error);
    yield put({ type: POST_PORTOFOLIO_ERROR, error });
  }
}

export default function* post_portofolio() {
  yield takeLatest(POST_PORTOFOLIO_START, create);
}